import React, { useEffect, useState, } from 'react';
import Mensagens from '../../components/Mensagens'


export function useFetchPost(fetch, url, data, dependencies) {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedData, setFetchedData] = useState(null);

    useEffect(() => {
        console.log('Feching custom hook ' + url, data);

        setIsLoading(true);

        fetch().post(url, data)
            .then(function (response) {
                setIsLoading(false);
                setFetchedData(response.data);
            })
            .catch(function (error) {
                setIsLoading(false);
                setFetchedData(null);
                console.log(error);
            });
    }, dependencies);

    return [fetchedData, isLoading, setFetchedData];
}

export function useFetchPostV2(fetch, url, data) {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedData, setFetchedData] = useState(null);
    const [listarAux, setListarAux] = useState(0);

    const listar = () => setListarAux(listarAux + 1);

    useEffect(() => {

        if (listarAux > 0 && !isLoading) {
            setIsLoading(true);

            fetch().post(url, data)
                .then(function (response) {
                    setIsLoading(false);
                    //console.log('fetched', response.data);
                    if (response) {
                        setFetchedData(response.data);
                    }
                    else {
                        setFetchedData(null);
                    }

                })
                .catch(function (error) {
                    setIsLoading(false);
                    setFetchedData(null);
                    console.log('erro: ', error);
                });
        }

    }, [listarAux]);

    return [fetchedData, listar, isLoading, setFetchedData];
}

export function useFetchPostV3(fetch, url, data) {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedData, setFetchedData] = useState(null);

    useEffect(() => {

        if (data && !isLoading) {
            setIsLoading(true);

            fetch().post(url, data)
                .then(function (response) {
                    setIsLoading(false);
                    setFetchedData(response.data);
                })
                .catch(function (error) {
                    setIsLoading(false);
                    setFetchedData(null);
                    console.log('erro: ', error);
                });
        }

    }, [data]);

    return [fetchedData, isLoading, setFetchedData];
}

export function useSavePost(fetch, url, data, fn) {
    const [isSaving, setIsSaving] = useState(false);
    const [saveAux, setSaveAux] = useState(0);

    const save = () => setSaveAux(saveAux + 1);

    useEffect(() => {

        if (saveAux > 0 && !isSaving) {

            setIsSaving(true);

            fetch().post(url, data)
                .then(function (response) {
                    setIsSaving(false);

                    if (response.data.sucesso) {
                        if (fn) {
                            fn(response.data.dados);
                        }
                    }
                    else {
                        Mensagens.showErro(response.data.msg ? response.data.msg : 'Erro ao gravar os dados');
                        console.log(response.data.msg);
                    }

                })
                .catch(function (error) {
                    setIsSaving(false);
                    console.log(error);
                });
        }

    }, [saveAux]);

    return [save, isSaving];
}

export function useSaveFile(fetch, fileList, fn, fnError) {
    const url = 'file/save';
    const [isSaving, setIsSaving] = useState(false);
    const [saveAux, setSaveAux] = useState(0);

    const save = () => setSaveAux(saveAux + 1);

    useEffect(() => {

        if (saveAux > 0 && !isSaving) {

            setIsSaving(true);


            const formData = new FormData();
            //formData.append("dados", JSON.stringify({ modelo: 'certificado' }));
            fileList.forEach((file) => {
                formData.append('files[]', file);
            });

            fetch().post(url, formData, { headers: { 'content-type': `multipart/form-data; boundary=${formData._boundary}` } })
                .then(function (response) {
                    setIsSaving(false);
                    if (response.data.sucesso) {
                        if (fn) {
                            fn(response.data.dados);
                        }
                    }
                    else {
                        console.log(response.data.msg);
                    }

                })
                .catch(function (error) {
                    setIsSaving(false);
                    if (fnError) {
                        fnError(error);
                    }
                    //console.log(error);
                });
        }

    }, [saveAux]);

    return [save, isSaving];
}

export function useFileSend(fetch, data, fileList, fn, fnError) {
    const url = 'file';
    const [isLoading, setIsLoading] = useState(false);
    const [sendAux, setSendAux] = useState(0);

    const save = () => setSendAux(sendAux + 1);

    useEffect(() => {

        if (sendAux > 0 && !isLoading) {

            setIsLoading(true);


            const formData = new FormData();
            formData.append("dados", JSON.stringify(data));
            fileList.forEach((file) => {
                formData.append('files[]', file);
            });

            fetch().post(url, formData, { headers: { 'content-type': `multipart/form-data; boundary=${formData._boundary}` } })
                .then(function (response) {
                    setIsLoading(false);
                    if (response.data.sucesso) {
                        if (fn) {
                            fn(response.data.dados);
                        }
                    }
                    else {
                        console.log(response.data.msg);
                    }

                })
                .catch(function (error) {
                    setIsLoading(false);
                    if (fnError) {
                        fnError(error);
                    }
                });
        }

    }, [sendAux]);

    return [save, isLoading];
}

export function useDownloadFile(fetch, fn) {
    const [isLoading, setIsLoading] = useState(false);
    const [dados, setDados] = useState(null);

    useEffect(() => {

        if (dados && !isLoading) {
            setIsLoading(true);
            fetch().post('/file/url', dados)
                .then(function (response) {
                    setIsLoading(false);
                    console.log(response.data);

                    if (response.data.url) {
                        if (fn) {
                            fn(response.data.url);
                        }
                    }
                    else {
                        Mensagens.showErro(response.data.msg ? response.data.msg : 'Erro ao gravar os dados');
                        console.log(response.data.msg);
                    }

                })
                .catch(function (error) {
                    setIsLoading(false);
                    console.log(error);
                });
        }

    }, [dados]);

    return [setDados, isLoading];
}

export function useSavePostClick(fetch, url, fn) {
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState(0);

    const save = d => setData(d);

    useEffect(() => {

        if (data && !isSaving) {

            setIsSaving(true);

            fetch().post(url, data)
                .then(function (response) {
                    setIsSaving(false);

                    if (response.data.sucesso) {
                        if (fn) {
                            fn(response.data.dados);
                        }
                    }
                    else {
                        Mensagens.showErro(response.data.msg ? response.data.msg : 'Erro ao gravar os dados');
                        console.log(response.data.msg);
                    }

                })
                .catch(function (error) {
                    setIsSaving(false);
                    console.log(error);
                });
        }

    }, [data]);

    return [save, isSaving];
}